// app/plugins/100-prefetch-settings.client.ts

export default defineNuxtPlugin(async (nuxtApp) => {
    const settingsStore = useSettingsStore();
    if (settingsStore.isPublicLoaded) return;

    const load = async () => {
        try {
            await settingsStore.loadPublic()
        } catch (e) {
            console.error('Settings prefetch failed:', e)
        }
    }
    // Client-rendered account/checkout pages still need these settings before setup.
    if (nuxtApp.payload.serverRendered) onNuxtReady(load)
    else await load()
})
